import React, { Component } from "react";
import { AuthShell } from "./AuthShell";
import { InlineSpinner } from "../components/InlineSpinner";

import { Link } from "react-router-dom";
import { PasswordInput } from "./PasswordInput";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { login } from "../actions/user";

class Landing extends Component {
  constructor(props) {
    super(props);
    this.state = {
      submitting: false,
      login: {
        email: "",
        password: "",
      },
    };

    this.handleLogin = this.handleLogin.bind(this);
    this.handleLoginInputs = this.handleLoginInputs.bind(this);
  }

  handleLoginInputs(event) {
    const { value, name } = event.currentTarget;

    this.setState((prevState) => ({
      login: { ...prevState.login, [name]: value },
    }));
  }

  // ponytail: garde le spinner au moins 400ms, sinon une réponse quasi
  // instantanée ne laisse rien voir (même parti pris que la page contact).
  runSubmit(promise) {
    this.setState({ submitting: true });
    const started = Date.now();
    promise.finally(() => {
      const wait = Math.max(0, 400 - (Date.now() - started));
      setTimeout(() => this.setState({ submitting: false }), wait);
    });
  }

  handleLogin(event) {
    event.preventDefault();
    const { email, password } = this.state.login;
    this.runSubmit(this.props.login(email, password));
  }

  render() {
    return (
      <AuthShell title="Sign in to your account">
        <form className="lg-form" onSubmit={this.handleLogin}>
          {this.props.loginMessage ? (
            <div className="lg-error" role="alert">
              {this.props.loginMessage}
            </div>
          ) : null}

          <div className="lg-field">
            <label htmlFor="login-email">Email</label>
            <input
              id="login-email"
              name="email"
              type="email"
              placeholder="you@company.com"
              onChange={this.handleLoginInputs}
              value={this.state.login.email}
              autoComplete="email"
              required
            />
          </div>

          <div className="lg-field">
            <label htmlFor="login-password">Password</label>
            <PasswordInput
              id="login-password"
              name="password"
              value={this.state.login.password}
              onChange={this.handleLoginInputs}
              autoComplete="current-password"
            />
            <Link className="lg-forgot" to="/password/askPasswordReset">
              Forgot your password?
            </Link>
          </div>

          <button
            className="lg-submit"
            type="submit"
            disabled={this.state.submitting}
          >
            {this.state.submitting ? (
              <>
                <InlineSpinner /> Signing in...
              </>
            ) : (
              "Log in"
            )}
          </button>
        </form>
      </AuthShell>
    );
  }
}

function mapStateToProps(store) {
  const { loginMessage } = store.requests;

  return {
    loginMessage,
  };
}

Landing.propTypes = {
  loginMessage: PropTypes.string.isRequired,
  login: PropTypes.func.isRequired,
};

export default connect(mapStateToProps, {
  login,
})(Landing);
